export default {
  sm: `
  DATA CENTER GAK Sejong
  is the powerhouse of all of
  NAVER's cutting-edge
  technologies and services,
  as well as the substance of
  future technologies.
  `,
  md: `
  DATA CENTER GAK Sejong
  is the powerhouse of all of NAVER's cutting-edge
  technologies and services,
  as well as the substance of future technologies.
  `,
};
